import CurrencyInput from 'react-currency-input-field';
import classNames from 'classnames';

import { OrderTypeEnum } from '../../../lib/enums/order-type.enum';
import lang from '../../../lib/language';

import { useIsIosDevice } from '../../../hooks';
import { Error } from '../..';

import styles from '../styles.module.scss';

type Props = {
  initialPrice: number;
  orderType: string;
  targetPriceError: string;
  setTargetPrice: (value: number) => void;
  setTargetPriceError: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
  errorClassName?: string;
}

const LimitPriceInput = ({
  disabled,
  orderType,
  initialPrice,
  targetPriceError,
  setTargetPrice,
  setTargetPriceError,
  onFocus,
  onBlur,
  errorClassName,
}: Props) => {
  const isIosUser = useIsIosDevice();
  const decimalSeparator = isIosUser ? ',' : '.';
  const groupSeparator = isIosUser ? '.' : ',';

  return (
    <>
      <div className={styles.wrapperLimitMarketPrice}>
        <div className={disabled ? styles.limitInputDisabled : ''}>
          {orderType === OrderTypeEnum.Stop
            ? lang.mobileTradingTicketStopPrice2()
            : lang.mobileTradingTicketLimitPrice()}
        </div>
        <CurrencyInput
          decimalSeparator={decimalSeparator}
          groupSeparator={groupSeparator}
          defaultValue={initialPrice}
          onValueChange={(amount) => {
            if (amount && isIosUser) {
              setTargetPrice(Number(amount.replace(',', '.')));
            } else {
              setTargetPrice(Number(amount));
            }
            setTargetPriceError('');
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          className={classNames(styles.wrapperPriceField, { [styles.limitInputError]: targetPriceError.trim() !== '' })}
          placeholder="$0.00"
          allowNegativeValue={false}
          prefix={'$'}
          maxLength={14}
        />
      </div>
      {(targetPriceError.trim() !== '') && (
        <div className={classNames(styles.errorWrapper, errorClassName)}>
          <Error hiddenIcon errorMessage={targetPriceError} />
        </div>
      )}
    </>
  );
};

export default LimitPriceInput;
